<mat-card>
  <form [formGroup]="">
    <div fxLayout="column" fxLayoutGap="20px">

      <div *ngIf="profile?.userId" fxLayout="row" fxLayoutGap="15px">

        <button *ngIf="(userPermissions | async).marketing.write"
                (click)="modify()" mat-stroked-button color="primary">
          <mat-icon>create</mat-icon> <span> Edytuj</span>
        </button>

        <button *ngIf="(userPermissions | async).marketing.write"
                (click)="addPurchase()" mat-stroked-button color="primary">
          <mat-icon>add</mat-icon> <span> Dodaj</span>
        </button>

        <button *ngIf="(userPermissions | async).marketing.delete"
                (click)="delete()" mat-stroked-button color="warn">
          <mat-icon>delete</mat-icon> <span> Usuń</span>
        </button>
      </div>

      <div class="id-info">
        <mat-form-field appearance="fill" color="accent">
          <mat-label>ID</mat-label>
          <input matInput placeholder="ID" [disabled]="true" [value]="warehouseProductObject?.recordId?.toString()">
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start">

        <div fxFlex="100" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start start">
          <mat-card fxFlex="50">
            <h3>Dane produktu</h3>

            <div>
              <div class="user-avatar" *ngIf="warehouseProductObject?.filename"
                   matRipple
                   [matRippleCentered]="false"
                   [matRippleDisabled]="false"
                   [matRippleUnbounded]="false"
                   [matRippleRadius]="10"
                   [matRippleColor]="'grey'" >
                <img src="/rest/crm/product/{{warehouseProductObject.uuid}}/image?{{imgCnt}}" alt="Zdjęcie" height="160"/>
              </div>
              <span fxFlex></span>
              <input #imageSelect type="file" style="display: none" [formControl]="imageSelectControl"
                     accept=".jpg,.gif,.png,.jpeg"/>
            </div>

            <div fxLayout="column" fxLayoutGap="10px">
              <div fxLayout="row" fxLayoutGap="10px">
                <app-detail fxFlex="100" header="Kategoria"
                            [value]="warehouseProductObject?.category?.name">
                </app-detail>

                <app-detail fxFlex="100" header="Nazwa produktu"
                            [value]="warehouseProductObject?.productName">
                </app-detail>
              </div>

              <div fxLayout="row" fxLayoutGap="10px">
                <app-detail fxFlex="100" header="Ilość na stanie"
                            [value]="warehouseProductObject?.productAmount?.toString()">
                </app-detail>

                <app-detail fxFlex="100" header="Magazyn"
                            [value]="warehouseProductObject?.warehouse?.name">
                </app-detail>
              </div>

              <app-detail-bool header="Wymagany protokół"
                               [value]="warehouseProductObject?.protocol">
              </app-detail-bool>
            </div>
          </mat-card>
          <div fxFlex="100" fxLayout="row" fxLayoutGap="10px">
            <mat-card fxFlex="100">
              <div>
                <h3>Uwagi</h3>
                <app-detail header="Uwagi"
                            [value]="warehouseProductObject?.note">
                </app-detail>
              </div>
            </mat-card>
          </div>

        </div>

      </div>

      <div fxFlex="100" fxLayout="row" fxLayoutGap="10px">
        <mat-card fxFlex="50">
          <div fxLayout="column" fxLayoutGap="15px">

            <table mat-table [dataSource]="purchases" matSort>
              <ng-container matColumnDef="purchaseDate">
                <th mat-header-cell *matHeaderCellDef> Data zakupu </th>
                <td mat-cell *matCellDef="let element">
                  {{element.purchaseDate | date:'y-MM-dd'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef> Firma </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.company?.name}}
                </td>
              </ng-container>

              <ng-container matColumnDef="expirationDate">
                <th mat-header-cell *matHeaderCellDef> Data ważności </th>
                <td mat-cell *matCellDef="let element">
                  {{element?.expirationDate | date:'y-MM-dd'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef> Ilość </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.amount}}
                </td>
              </ng-container>

              <ng-container matColumnDef="issued">
                <th mat-header-cell *matHeaderCellDef> Wydane </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.issued}}
                </td>
              </ng-container>

              <ng-container matColumnDef="left">
                <th mat-header-cell *matHeaderCellDef> Pozostało </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.amountLeft}}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['purchaseDate', 'company', 'expirationDate', 'amount', 'issued', 'left']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['purchaseDate', 'company', 'expirationDate', 'amount', 'issued', 'left'];"></tr>
            </table>
          </div>
        </mat-card>
      </div>
    </div>
  </form>
</mat-card>
